module.exports = __webpack_public_path__ + "static/media/background-5.eee2d459.jpeg";